module.exports = __webpack_public_path__ + "static/media/pinterest_icon.7fb21672.svg";